import type { RouteLocationNormalizedGeneric } from 'vue-router'

export function castRouteIds(route: RouteLocationNormalizedGeneric) {
	const params: Record<string, any> = {}
	for (const prop in route.params) {
		if (!Object.prototype.hasOwnProperty.call(route.params, prop)) {
			continue
		}
		const value = route.params[prop]
		if (typeof value === 'string' && /^\d+$/.test(value)) {
			params[prop] = parseInt(value)
		} else params[prop] = value
	}
	return params
}
